import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row, Col, Card, Button } from "react-bootstrap";

export default function ThankYouSafetyPage() {
  const handleExplore = () => {
    window.location.href = "https://clideanalyser.com/engage";
  };

  useEffect(() => {
    document.body.style.background =
      "linear-gradient(135deg, #0f2027, #203a43, #2c5364)";
    return () => {
      document.body.style.background = "";
    };
  }, []);

  return (
    <div className="d-flex align-items-center justify-content-center" style={{ minHeight: "100vh" }}>
      <Container>
        <Row className="justify-content-center">
          <Col md={10} lg={8}>
            <Card
              className="border-0 shadow-lg text-center p-2 p-md-3"
              style={{
                borderRadius: "20px",
                backdropFilter: "blur(10px)",
                background: "rgba(255, 255, 255, 0.95)",
                animation: "fadeIn 0.8s ease-in-out",
              }}
            >
              <Card.Body>
                <div
                  className="mb-4 d-inline-flex align-items-center justify-content-center"
                  style={{
                    width: "100px",
                    height: "100px",
                    borderRadius: "50%",
                    background: "linear-gradient(135deg,rgb(243, 167, 126), rgb(255, 90, 31))",
                    fontSize: "45px",
                    color: "white",
                    boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
                  }}
                >
                  👍🏻
                </div>

                <h1 className="fw-bold mb-3" style={{ fontSize: "2.5rem" }}>
                  Thank You for Participating!
                </h1>

                <p className="lead text-secondary">
                  Your response has been successfully submitted.
                </p>

                <hr className="my-4" />

                <p className="text-muted">
                  At <strong>CLIDE Analyser Safety Software</strong>, every voice matters.
                  Your participation during <strong>Safety Week (4th March – 11th March 2026)</strong>
                  {" "}contributes to building a stronger, smarter, and safer workplace.
                </p>

                <p className="text-muted">
                  Safety is not just a compliance requirement — it is a shared
                  responsibility and a culture we build together.
                </p>

                <p className="text-muted">
                  We appreciate your time and commitment toward proactive safety
                  engagement.
                </p>

                <div className="mt-4 text-start text-md-center fw-medium">
                  <p className="mb-2">🔹 Continue being a Safety Champion</p>
                  <p className="mb-2">🔹 Encourage others to participate</p>
                  <p className="mb-2">🔹 Make safety a daily habit</p>
                </div>

                <div className="mt-5">
                  <Button
                    size="lg"
                    onClick={handleExplore}
                    style={{
                      padding: "12px 35px",
                      borderRadius: "50px",
                      fontWeight: "600",
                      fontSize: "1.1rem",
                      background: "linear-gradient(135deg,rgb(239, 151, 103), rgb(255, 90, 31))",
                      border: "none",
                      boxShadow: "0 8px 20px rgba(0,0,0,0.25)",
                      transition: "all 0.3s ease",
                    }}
                    onMouseOver={(e) =>
                      (e.target.style.transform = "scale(1.05)")
                    }
                    onMouseOut={(e) =>
                      (e.target.style.transform = "scale(1)")
                    }
                  >
                    Explore CLIDE Analyser
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}
